import {noMinimumTest} from './constants/signalmanConstants';

export function fireNoMinimumTestAnalyticsEvent({location = 'pdp catalog'}) {
  window.dataLayer.push({
    ab_test_group: noMinimumTest,
    ab_test_location: location,
    ab_test_name: '2025 04 17 no min filter',
    event: 'ab_test_group'
  });
}

export function noMinimumTestEnabled() {
  return noMinimumTest === 'test';
}
